module.exports = __webpack_public_path__ + "img/inside.031bf491.jpg";